import { SchemaPhone } from '@/models/SchemaPhone.js'

export const initialState = {
    started: false,
    verified: false,
    form_data: new SchemaPhone()
}

export const state = initialState
